export enum AuthorizationErrorCode {
  UnauthorizedClient = 'unauthorized_client',
  AccessDenied = 'access_denied',
  UnsupportedResponseType = 'unsupported_response_type',
  InvalidScope = 'invalid_scope',
  UnsupportedResponseMode = 'unsupported_response_mode',
  RedirectUriDoesNotMatch = 'redirect_uri_does_not_match',
  InvalidOpenIdConnectClient = 'invalid_open_id_connect_client',
  InvalidRequest = 'invalid_request',
  TemporarilyUnavailable = 'temporarily_unavailable',
  ServerError = 'server_error',
}
